import React from "react";
import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import DataSourcePage from "./datasources/DataSourcesPage";
import { User } from "../models/API";

interface DataSourceComponentProps {
  isOpen: boolean;
  menuWidth: number;
  currentTeamId: number;
  currentUserName: string;
  userConfig: User | null;
  effectiveRole: string;
}

// @ts-ignore
export const DataSourcesComponent: React.FC<DataSourceComponentProps> = ({
  isOpen,
  menuWidth,
  currentTeamId,
  currentUserName,
  userConfig,
  effectiveRole,
}) => {
  const theme = useTheme();

  if (!isOpen) {
    return null;
  }

  // @ts-ignore
  return (
    isOpen && (
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          ml: `${menuWidth}px`,
          transition: theme.transitions.create("margin-left", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.standard,
          }),
        }}
      >
        <DataSourcePage
          currentUserId={userConfig?.id!}
          currentUserName={currentUserName}
          userConfig={userConfig!}
          effectiveRole={effectiveRole}
        />
      </Box>
    )
  );
};

export default DataSourcesComponent;
